<template>
	<div>
		<!--<aside class="section section&#45;&#45;footer">
			<div class="col-layout col-layout&#45;&#45;3">
				<div class="col-layout__row">
					<div class="col-layout__item">
						<a href="#jouons-responsable">
							<img src="@/assets/img/tiles__item&#45;&#45;responsable.jpg" alt="Jouons responsable">
						</a>
					</div>
					<div class="col-layout__item">
						<a href="#app-sorec">
							<img src="@/assets/img/tiles__item&#45;&#45;app.jpg"
								 alt="Toute l'information hippique à portée de main">
						</a>
					</div>
					<div class="col-layout__item">
						<a href="tel:0537271212">
							<img src="@/assets/img/tiles__item&#45;&#45;support.jpg" alt="Service client">
						</a>
					</div>
				</div>
			</div>

		</aside>-->
		<aside class="section tiles threeImages">
			<div class="row">
				<div class="col-md-4 col-sm-4 col-xs-12">
					<banner :priority="1"></banner>
				</div>
				<div class="col-md-4 col-sm-4 col-xs-12">
					<banner :priority="2"></banner>
				</div>
				<div class="col-md-4 col-sm-4 col-xs-12">
					<banner :priority="3"></banner>
				</div>
			</div>
		</aside>
		<div class="prefooter" v-if="prefooter"></div>
	</div>
</template>
<script>

	import Banner from '@/components/parts/Banner';

	export default {
		name: 'aside-prefooter',
		components: {
			'banner': Banner
		},
		props: {
			prefooter: {
				type: Boolean,
				default: false
			}
		},
		data() {
			return {}
		},
		mounted() {

		},
		methods: {}
	}
</script>